export class ChangePass {

	success: boolean;
	message: string;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-pass/model/change-pass.ts